import { api } from '@marketplace-web/core-api/core-api-client-data'

import {
  GetBusinessAccountPoliciesArgs,
  BusinessAccountPoliciesResp,
  SetBusinessAccountPoliciesArgs,
} from '../types/policies'
import { setBusinessAccountPoliciesArgsToParams } from '../transformers/policies'

export const getBusinessAccountPolicies = ({ businessAccountId }: GetBusinessAccountPoliciesArgs) =>
  api.get<BusinessAccountPoliciesResp>(`/business_accounts/${businessAccountId}/terms`)

export const setBusinessAccountPolicies = (args: SetBusinessAccountPoliciesArgs) =>
  api.post<BusinessAccountPoliciesResp>(
    `/business_accounts/${args.businessAccountId}/terms`,
    setBusinessAccountPoliciesArgsToParams(args),
  )
